export const companyConsentText =
  "En cochant cette case, j'accepte de recevoir des parcours de micro-formation via SMS de cette organisation.\nJe pourrai me désinscrire à tout moment de chaque parcours.\nMon numéro ne sera en aucun cas diffusé à des tiers.";
